module.exports = require("./fr-MA");